import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;

export const filterExistingItems = (suggestions, items) => {
    if (!suggestions || !suggestions.length || !items || !items.length) {
        return suggestions;
    }
    return suggestions.filter((sItem) => !items.some((item) => sItem.id === item.id || sItem.id === item.coaEmpId));
};

export const createGetSuggestionsFromApiUrl = (suggestionsApiUrl, customQuery) => {
    const getSuggestions = async (userInput) => {
        let query = customQuery || '';
        
        if (!userInput || !userInput.length) {
            return [];
        }

        if (cancel !== undefined) {
            cancel();
        }

        const config = {
            params: { input: query ? userInput + " " + query : userInput},
            cancelToken: new CancelToken((c) => (cancel = c)),
        };

        const suggestions = await axios
            .get(suggestionsApiUrl, config)
            .then((response) => {
                return response.data ?? null;
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                    return [];
                }
                return null;
            });

        return suggestions;
    };

    return getSuggestions;
};

export const createGetTeacherSuggestionsFromApiUrl = (suggestionsApiUrl, courseId) => {
    const getSuggestions = async (userInput) => {

        if (!userInput || !userInput.length) {
            return [];
        }

        if (cancel !== undefined) {
            cancel();
        }

        const config = {
            params: { input: userInput, courseId: courseId },
            cancelToken: new CancelToken((c) => (cancel = c)),
        };

        const suggestions = await axios
            .get(suggestionsApiUrl, config)
            .then((response) => {
                return response.data ?? null;
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                    return [];
                }
                return null;
            });

        return suggestions;
    };

    return getSuggestions;
};

export const FilterChangelogPatch = (patch) => {
    let changelogPatch = [];

    patch.forEach(p => {
        if (p.path.split('/').length < 3 || (p.op == 'add' && p.path.split('/').length == 3)) {
            changelogPatch.push(p);
        }
        else if (p.op == 'remove' && p.path.split('/').length == 3) {
            let removedId = p.oldValue?.id;
            if ((patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.oldValue == removedId) &&
                !patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.value == removedId)) ||
                (!patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.value == removedId) &&
                !patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.oldValue == removedId))) {
                changelogPatch.push(p);
            }
        }
        else if (p.op == 'replace' && p.path.split('/').length == 4 && p.path.split('/')[3] == 'id') {
            if (!patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.value == p.oldValue)) {
                let patchCopy = { ...p };
                patchCopy.value = null;
                patchCopy.op = 'remove';
                changelogPatch.push(patchCopy);
            }
            if (!patch.find(o => o.op == 'replace' && o.path.split('/').length == 4 && o.path.split('/')[3] == 'id' && o.oldValue == p.value) &&
                !patch.find(o => o.op == 'remove' && o.path.split('/').length == 3 && o.oldValue.id == p.value)) {
                let patchCopy2 = { ...p };
                patchCopy2.oldValue = null;
                patchCopy2.op = 'add';
                changelogPatch.push(patchCopy2);
            }
        }
    });

    return changelogPatch;
};
